'use strict';

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

var _require = require('events'),
    EventEmitter = _require.EventEmitter;

var _require2 = require('multiaddr'),
    Multiaddr = _require2.Multiaddr;

var PeerId = require('peer-id');
/**
 * @typedef {Object} AddressManagerOptions
 * @property {string[]} [listen = []] - list of multiaddrs string representation to listen.
 * @property {string[]} [announce = []] - list of multiaddrs string representation to announce.
 */

/**
 * @fires AddressManager#change:addresses Emitted when a addresses change.
 */


var AddressManager = /*#__PURE__*/function (_EventEmitter) {
  _inherits(AddressManager, _EventEmitter);

  var _super = _createSuper(AddressManager);

  /**
   * Responsible for managing the peer addresses.
   * Peers can specify their listen and announce addresses.
   * The listen addresses will be used by the libp2p transports to listen for new connections,
   * while the announce addresses will be used for the peer addresses' to other peers in the network.
   *
   * @class
   * @param {PeerId} peerId - The Peer ID of the node
   * @param {object} [options]
   * @param {Array<string>} [options.listen = []] - list of multiaddrs string representation to listen.
   * @param {Array<string>} [options.announce = []] - list of multiaddrs string representation to announce.
   */
  function AddressManager(peerId) {
    var _this;

    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$listen = _ref.listen,
        listen = _ref$listen === void 0 ? [] : _ref$listen,
        _ref$announce = _ref.announce,
        announce = _ref$announce === void 0 ? [] : _ref$announce;

    _classCallCheck(this, AddressManager);

    _this = _super.call(this);
    _this.peerId = peerId;
    _this.listen = new Set(listen.map(function (ma) {
      return ma.toString();
    }));
    _this.announce = new Set(announce.map(function (ma) {
      return ma.toString();
    }));
    _this.observed = new Set();
    return _this;
  }
  /**
   * Get peer listen multiaddrs.
   *
   * @returns {Multiaddr[]}
   */


  _createClass(AddressManager, [{
    key: "getListenAddrs",
    value: function getListenAddrs() {
      return Array.from(this.listen).map(function (a) {
        return new Multiaddr(a);
      });
    }
    /**
     * Get peer announcing multiaddrs.
     *
     * @returns {Multiaddr[]}
     */

  }, {
    key: "getAnnounceAddrs",
    value: function getAnnounceAddrs() {
      return Array.from(this.announce).map(function (a) {
        return new Multiaddr(a);
      });
    }
    /**
     * Get observed multiaddrs.
     *
     * @returns {Array<Multiaddr>}
     */

  }, {
    key: "getObservedAddrs",
    value: function getObservedAddrs() {
      return Array.from(this.observed).map(function (a) {
        return new Multiaddr(a);
      });
    }
    /**
     * Add peer observed addresses
     *
     * @param {string | Multiaddr} addr
     */

  }, {
    key: "addObservedAddr",
    value: function addObservedAddr(addr) {
      var ma = new Multiaddr(addr);
      var remotePeer = ma.getPeerId(); // strip our peer id if it has been passed

      if (remotePeer) {
        var remotePeerId = PeerId.createFromB58String(remotePeer); // use same encoding for comparison

        if (remotePeerId.equals(this.peerId)) {
          ma = ma.decapsulate(new Multiaddr("/p2p/".concat(this.peerId)));
        }
      }

      var addrString = ma.toString(); // do not trigger the change:addresses event if we already know about this address

      if (this.observed.has(addrString)) {
        return;
      }

      this.observed.add(addrString);
      this.emit('change:addresses');
    }
  }]);

  return AddressManager;
}(EventEmitter);

module.exports = AddressManager;